"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _withMapping = _interopRequireDefault(require("../../../Context/withMapping"));

var _GenericFormElement = _interopRequireDefault(require("../GenericFormElement"));

require("./style.scss");

var _excluded = ["title", "required", "description", "placeholder", "fieldName", "validation", "touched", "error", "value", "displayRequiredIndicator", "onChange", "className", "wrapperClassName", "disabled"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TextField = function TextField(props) {
  var title = props.title,
      required = props.required,
      description = props.description,
      placeholder = props.placeholder,
      fieldName = props.fieldName,
      validation = props.validation,
      touched = props.touched,
      error = props.error,
      value = props.value,
      displayRequiredIndicator = props.displayRequiredIndicator,
      onChange = props.onChange,
      className = props.className,
      wrapperClassName = props.wrapperClassName,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      restProps = _objectWithoutProperties(props, _excluded);

  var type = props.type || 'text';

  var handleChange = function handleChange(e) {
    var handleChange = props.handleChange;

    if (handleChange) {
      handleChange(e);
    }

    if (onChange) {
      onChange(e);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_GenericFormElement.default, {
    className: (0, _classnames.default)('TextField', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: touched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({}, restProps, {
    className: (0, _classnames.default)(className, {
      'error': error && touched
    }),
    id: fieldName,
    name: fieldName,
    type: type,
    value: value,
    placeholder: placeholder,
    validate: validation,
    onKeyUp: handleChange,
    disabled: disabled
  })));
};

var _default = (0, _withMapping.default)(TextField);

exports.default = _default;